import { ExchangeResource, ShiftExchangeViewModel } from '@/models'
import {
    APP_LOGOUT,
    EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_FAILURE,
    EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_REQUEST,
    EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_SUCCESS,
    EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_FAILURE,
    EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_REQUEST,
    EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_SUCCESS,
    EXCHANGE_SHIFTS_FAILURE,
    EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_FAILURE,
    EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_REQUEST,
    EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_SUCCESS,
    EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_FAILURE,
    EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_REQUEST,
    EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_SUCCESS,
    EXCHANGE_SHIFTS_OPEN_SUCCESS,
    EXCHANGE_SHIFTS_PLANNED_SUCCESS,
    EXCHANGE_SHIFTS_REQUEST,
    EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_FAILURE,
    EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_REQUEST,
    EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_SUCCESS,
    EXCHANGE_SUCCESS,
} from '@/redux/actionTypes'

export interface ExchangesState {
    shiftsOfferedByMe: ExchangeResource[]
    shiftsOfferedForMe: ExchangeResource[]
    shiftExchanges: ShiftExchangeViewModel[]
    exchange: ExchangeResource | null
    shiftExchange: ShiftExchangeViewModel | null
    loading: boolean
    errors?: unknown[]
}

export type ExchangesAction =
    | {
        type: typeof EXCHANGE_SHIFTS_REQUEST
            | typeof EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_REQUEST
            | typeof EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_REQUEST
            | typeof EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_REQUEST
            | typeof EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_REQUEST
            | typeof EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_REQUEST
    }
    | { type: typeof EXCHANGE_SHIFTS_PLANNED_SUCCESS, shiftsOfferedByMe: ExchangeResource[] }
    | { type: typeof EXCHANGE_SHIFTS_OPEN_SUCCESS, shiftsOfferedForMe: ExchangeResource[] }
    | { type: typeof EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_SUCCESS, shiftExchanges: ShiftExchangeViewModel[] }
    | { type: typeof EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_SUCCESS, shiftExchange: ShiftExchangeViewModel }
    | {
        type: typeof EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_SUCCESS
            | typeof EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_SUCCESS
            | typeof EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_SUCCESS
    }
    | {
        type: typeof EXCHANGE_SHIFTS_FAILURE
            | typeof EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_FAILURE
            | typeof EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_FAILURE
            | typeof EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_FAILURE
            | typeof EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_FAILURE
            | typeof EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_FAILURE
        errors?: unknown[]
    }
    | { type: typeof EXCHANGE_SUCCESS, exchange: ExchangeResource | null }
    | { type: typeof APP_LOGOUT }

const initialState: ExchangesState = {
    shiftsOfferedByMe: [],
    shiftsOfferedForMe: [],
    shiftExchanges: [],
    exchange: null,
    shiftExchange: null,
    loading: false,
    errors: [],
}

export const exchangesReducer = (state: ExchangesState = initialState, action: ExchangesAction): ExchangesState => {
    switch (action.type) {
        case EXCHANGE_SHIFTS_REQUEST:
        case EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_REQUEST:
        case EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_REQUEST:
        case EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_REQUEST:
        case EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_REQUEST:
        case EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_REQUEST:
            return { ...state, loading: true }
        case EXCHANGE_SHIFTS_PLANNED_SUCCESS:
            return {
                ...state, loading: false, shiftsOfferedByMe: action.shiftsOfferedByMe,
            }
        case EXCHANGE_SHIFTS_OPEN_SUCCESS:
            return {
                ...state, loading: false, shiftsOfferedForMe: action.shiftsOfferedForMe,
            }
        case EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_SUCCESS:
            return {
                ...state, shiftExchanges: action.shiftExchanges, loading: false,
            }
        case EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_SUCCESS:
            return {
                ...state, shiftExchange: action.shiftExchange, loading: false,
            }
        case EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_SUCCESS:
        case EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_SUCCESS:
        case EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_SUCCESS:
            return { ...state, loading: false }
        case EXCHANGE_SHIFTS_FAILURE:
        case EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_FAILURE:
        case EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_FAILURE:
        case EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_FAILURE:
        case EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_FAILURE:
        case EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_FAILURE:
            return {
                ...state, loading: false, errors: action.errors,
            }
        case EXCHANGE_SUCCESS:
            return {
                ...state, loading: false, exchange: action.exchange,
            }
        case APP_LOGOUT:
            return { ...initialState }
        default:
            return state
    }
}
